const Cookies = require("js-cookie");

function getAnonymousUserIdFromCookie() {
  try {
    return Cookies.get("AnonymousUserId") || null;
  } catch (_e) {
    return null;
  }
}

function getFrontendAuthenticatedId() {
  if (typeof globalThis === "undefined") return null;

  if (globalThis.__current_user_id) {
    return `user_${globalThis.__current_user_id}`;
  }

  if (globalThis.__current_admin_user_id) {
    return `admin_${globalThis.__current_admin_user_id}`;
  }

  return null;
}

function getCurrentUserIdentifier() {
  return getFrontendAuthenticatedId() || getAnonymousUserIdFromCookie();
}

function isAuthenticated() {
  return !!getFrontendAuthenticatedId();
}

module.exports = {
  getAnonymousUserIdFromCookie,
  getFrontendAuthenticatedId,
  getCurrentUserIdentifier,
  isAuthenticated,
};
